import React from 'react'

export function ProductPrice({ productPrice }) {
    
    return (
        <p id='product-price'>{productPrice}</p>
    );
}
